// extracted by mini-css-extract-plugin
module.exports = {"hidden":"Header_hidden__kpU8J"};